/**
 * /dashboard/hiring/candidates — Candidates (HR-admin only).
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/hiring/candidates/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { HiringModuleShell } from "@/components/shared/hiring-module-shell";
import { HiringFeatureGate } from "@/components/hiring/hiring-feature-gate";
import { CandidatesTab } from "@/components/hiring/candidates-tab";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/hiring/candidates/")({
  component: HiringCandidatesRoute,
});

function HiringCandidatesRoute() {
  return (
    <HiringModuleShell
      title="Candidates"
      description="The talent pool feeding your pipelines (HR-admin only)."
    >
      <HiringFeatureGate>
        <CandidatesTab />
      </HiringFeatureGate>
    </HiringModuleShell>
  );
}
